import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import MultiSelect from 'vue-multiselect';
import { ItemViewModel } from '@/common/viewModels';
import { OnboardingRegistrationStatus } from '@/common/viewModels/Enums';

@Component({
  components: {
    MultiSelect,
  },
})
export default class RegistrationsFilter extends Vue {
  @Prop({ required: true }) filter!: string;
  @Prop({ required: true }) status!: OnboardingRegistrationStatus[];

  options: ItemViewModel[] = [
    { text: 'New', value: OnboardingRegistrationStatus.Submitted, disabled: false },
    { text: 'In Progress', value: OnboardingRegistrationStatus.Pending, disabled: false },
    { text: 'Failed', value: OnboardingRegistrationStatus.Error, disabled: false },
    { text: 'Cancelled', value: OnboardingRegistrationStatus.Cancelled, disabled: false },
    { text: 'Completed', value: OnboardingRegistrationStatus.Completed, disabled: false },
  ];

  get selectedOptions(): ItemViewModel[] {
    return this.status.reduce((items: any, status: any) => {
      const item: ItemViewModel | undefined = this.options.find((option) => option.value === status);
      items.push(item!);
      return items;
    }, []);

  }

  @Emit()
  filterChange(filter: string) {
    this.$emit('filterChange', filter);
  }

  @Emit()
  statusChange(status: string[]) {
    this.$emit('statusChange', status);
  }

}
